import { canBridgeUse, useBridge } from './common';

const namespace = 'ui';
const ua = typeof window !== 'undefined' ? navigator.userAgent : '';

/**
 * config参数按照yoda要求 { title, color }
 * @param {*} config
 * @returns {*} 调用结果
 */
export async function setPageTitle(config) {
    if (await canBridgeUse(namespace, 'setTitle')) {
        const nameSpaceApi = 'ui.setTitle';
        return await useBridge(nameSpaceApi, config);
    }
    if (await canBridgeUse(namespace, 'setPageTitle')) {
        const nameSpaceApi = 'ui.setPageTitle';
        return await useBridge(nameSpaceApi, config);
    }
    throw new Error('Bridge Unsupported: setPageTitle');
}

export const inYoda = ua.includes('Yoda/');
export const inIm = window.location.pathname.includes('im/message');
export const inCollect = window.location.hostname.includes('collect');
export const isDark = ua.includes('ISDM/1');
export const isHarmony = ua.indexOf('ArkWeb') > -1;